import React, { Component } from 'react';
import ReactGA from 'react-ga';
import async from 'async';
import $ from 'jquery';
import _ from 'lodash';
import AboutMe from './AboutMe.js';
import City from './City.js';
import LiveStream from './LiveStream.js';
import Runway from './Runway.js';
import blank from './image/blank.png';

class App extends Component {
	constructor(props) {
		super(props);
		var self = this;
		this.state = {
			showingMenu: false,
			subPage: null,
			data: {},
			runwayData: {},
			shortMenu: false
		};
		this.onScrolling = function() {
			var wrapper = document.getElementById('scrollable-area');
			if(wrapper.scrollTop > 0 && !self.state.shortMenu) {
				self.setState({
					shortMenu: true
				})
			} else if(wrapper.scrollTop === 0 && self.state.shortMenu) {
				self.setState({
					shortMenu: false
				})
			}
		}
	}
	switchSubPage(subPage, event) {
		event.stopPropagation();
		if(!!subPage) {
			if(subPage.page === "city") {
				window.history.pushState(subPage, null, window.location.pathname+"#"+subPage.page+":"+subPage.location);
			} else {
				window.history.pushState(subPage, null, window.location.pathname+"#"+subPage.page);
			}
		} else {
			window.history.pushState(subPage, null, window.location.pathname);
			ReactGA.set({
				'dimension1': ':mini:fashionweekfw17',
				'dimension2': ':mini',
				'dimension3': ':mini:fashionweekfw17',
				'dimension4': null
			});
			ReactGA.pageview('/');
		}
		this.setState({
			showingMenu: false,
			subPage: subPage
		});
		$('#scrollable-area').scrollTop(0);
	}
	closeMenu() {
		this.setState({
			showingMenu: false
		})
	}
	showMenu() {
		this.setState({
			showingMenu: true
		})
	}
	componentWillMount() {
		ReactGA.initialize('UA-51457352-1');
	}
	componentDidMount() {
		var self = this;
		async.parallel({
			data: function(callback) {
				$.getJSON("fashion-week-fw17/api/getData2.php", function(data) {
					callback(null, data);
				});
			},
			runwayData: function(callback) {
				$.getJSON("https://www.esquirehk.com/action/page/156602/0/0/json/(api)/1", function(data) {
					callback(null, data);
				});
			}
		}, function(err, result) {
			self.setState(result);
			if(window.location.hash.length > 0) {
				var url = window.location.hash.substr(1).split(":");
				if(url[0] === "city") {
					self.setState({
						subPage: {
							page: url[0],
							location: url[1]
						}
					});
				} else if(url[0] === "runway") {
					self.setState({
						subPage: {
							page: url[0],
							node: url[1],
							thumbnailIndex: ((!!url[3] && url[3].length) > 0 ? parseInt(url[3], 10) : undefined)
						}
					});
				} else {
					self.setState({
						subPage: {
							page: url[0]
						}
					});
				}
			} else {
				ReactGA.set({
					'dimension1': ':mini:fashionweekfw17',
					'dimension2': ':mini',
					'dimension3': ':mini:fashionweekfw17'
				});
				ReactGA.pageview('/');
			}
		});
		window.addEventListener("resize", function() {
			self.onResize();
		});
		window.addEventListener("popstate", function(e) {
			self.setState({
				showingMenu: false,
				subPage: e.state
			});
		});
	}
	componentWillUpdate(nextProps, nextState) {
		if(document.getElementById('scrollable-area') !== null && nextState.subPage === null) {
			document.getElementById('scrollable-area').removeEventListener("scroll", this.onScrolling);
			this.setState({
				shortMenu: false
			})
		}
	}
	componentDidUpdate(prevProps, prevState) {
		this.onResize();
		if(document.getElementById('scrollable-area') !== null && this.state.subPage !== null) {
			document.getElementById('scrollable-area').addEventListener("scroll", this.onScrolling);
		}
	}
	facebookShare() {
		var url = 'https://www.facebook.com/sharer/sharer.php?u=';
		var urlPara = window.location.origin+window.location.pathname + '?utm_source=facebook_share&utm_medium=referral&cid=facebook_share_referral';
		window.open(url + encodeURIComponent(urlPara), 'fbsharer', "status=no, toolbar=no, menubar=no, scrollbars=no, location=no, directories=no, width=626, height=335");
	}
	onResize() {
		if(!!$('#scrollable-area').offset()) {
			var bottom = 0;
			if($('#bottom').height() > 0) {
				bottom = $('#bottom').height()-15;
			}
			$('#scrollable-area').height($(window).height()-$('#scrollable-area').offset().top-bottom);
		}
	}
	setSubPageData(data) {
		_.assignIn(this.state.subPage, data);
		this.forceUpdate();
	}
	render() {
		return (
			<div className={"app"+(this.state.shortMenu ? " short" : "")}>
				<div id="header" className="header">
					<div className="title" onClick={this.switchSubPage.bind(this, null)}>
						<img src={blank} alt="Esquire HK – FW 17 Fashion Week Live" />
						<div className="esky"></div>
						<div className="aboutMe" onClick={this.switchSubPage.bind(this, {page: "aboutMe"})}></div>
					</div>
					<div className="menu-btn" onClick={this.showMenu.bind(this)}></div>
					<div className={"menu"+(this.state.showingMenu ? " active" : "")}>
						<div className="close-menu" onClick={this.closeMenu.bind(this)}></div>
						<ul>
							<li onClick={this.switchSubPage.bind(this, null)}>MAINPAGE</li>
							<li onClick={this.switchSubPage.bind(this, {page: "liveStream"})}>LIVESTREAM</li>
							<li onClick={this.switchSubPage.bind(this, {page: "city", location: "london"})}>LONDON</li>
							<li onClick={this.switchSubPage.bind(this, {page: "city", location: "florence"})}>FLORENCE</li>
							<li onClick={this.switchSubPage.bind(this, {page: "city", location: "milan"})}>MILAN</li>
							<li onClick={this.switchSubPage.bind(this, {page: "city", location: "paris"})}>PARIS</li>
							<li onClick={this.switchSubPage.bind(this, {page: "runway"})}>RUNWAY</li>
							<li onClick={this.switchSubPage.bind(this, {page: "aboutMe"})}>ABOUT ESKY</li>
						</ul>
						<div className="social">
							<span className="share" onClick={this.facebookShare.bind(this)}>SHARE</span>
							<span className="website">
								<a href="//www.esquirehk.com?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17" target="_blank">EsquireHK.com</a>
							</span>
						</div>
						<div className="footer">
							<div className="link">
								<div>
									<a href="//www.esquirehk.com/other/advertising?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17" target="_blank">Advertising</a>
								</div>
								<div>
									<a href="//www.esquirehk.com/other/privacy_statement?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17" target="_blank">Privacy Policy</a>
								</div>
								<div>
									<a href="//www.esquirehk.com/other/contact?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17" target="_blank">Contact Us</a>
								</div>
							</div>
							<div className="copyright">&copy;2016 SCMP Hearst Magazines Limited.<br />All Rights Reserved</div>
						</div>
					</div>
				</div>
				<div className={(this.state.subPage === null) ? 'page' : 'page hidden'}>
					<div className="index">
						<div className="desktop">
							<div className="livestream-text clickable" onClick={this.switchSubPage.bind(this, {page: "liveStream"})}></div>
							<div className="flashing-camera clickable" onClick={this.switchSubPage.bind(this, {page: "liveStream"})}></div>
							<div className="runway-text clickable" onClick={this.switchSubPage.bind(this, {page: "runway"})}></div>
							<div className="walking-esky clickable" onClick={this.switchSubPage.bind(this, {page: "runway"})}></div>
							<div className="hat"></div>
							<div className="bowtie"></div>
							<div className="stamp"></div>
							<div className="luggage"></div>
							<div className="paris-text clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "paris"})}></div>
							<div className="paris clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "paris"})}></div>
							<div className="london-text clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "london"})}></div>
							<div className="london clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "london"})}></div>
							<div className="florence-text clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "florence"})}></div>
							<div className="florence clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "florence"})}></div>
							<div className="milan-text clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "milan"})}></div>
							<div className="milan clickable" onClick={this.switchSubPage.bind(this, {page: "city", location: "milan"})}></div>
						</div>
						<div className="mobile">
							<div className="london" onClick={this.switchSubPage.bind(this, {page: "city", location: "london"})}></div>
							<div className="florence" onClick={this.switchSubPage.bind(this, {page: "city", location: "florence"})}></div>
							<div className="milan" onClick={this.switchSubPage.bind(this, {page: "city", location: "milan"})}></div>
							<div className="paris" onClick={this.switchSubPage.bind(this, {page: "city", location: "paris"})}></div>
						</div>
					</div>
					{
						(this.state.subPage === null) ?
							null
						:
							<div className="sub-page">
								<div className="sub-page-container">
									{
										(this.state.subPage.page === "aboutMe") ?
											<AboutMe />
										:
											(this.state.subPage.page === "city") ?
												(this.state.subPage.location === "florence") ?
													<City location={this.state.subPage.location} data={this.state.data.citys.FLORENCE} />
												:
													(this.state.subPage.location === "london") ?
														<City location={this.state.subPage.location} data={this.state.data.citys.LONDON} />
													:
														(this.state.subPage.location === "milan") ?
															<City location={this.state.subPage.location} data={this.state.data.citys.MILAN} />
														:
															(this.state.subPage.location === "paris") ?
																<City location={this.state.subPage.location} data={this.state.data.citys.PARIS} />
															:
																"Loading..."

											:
												(this.state.subPage.page === "liveStream") ?
													<LiveStream data={this.state.data.livestream} />
												:
													(this.state.subPage.page === "runway") ?
														<Runway node={this.state.subPage.node} thumbnailIndex={this.state.subPage.thumbnailIndex} data={this.state.runwayData} parent={this} />
													:
														null
									}
								</div>
							</div>
					}
				</div>
				<div id="bottom" className="bottom">
					<div onClick={this.switchSubPage.bind(this, {page: "runway"})}></div>
					<div onClick={this.switchSubPage.bind(this, {page: "liveStream"})}></div>
				</div>
				<div className="rotationAlert">
					<div className="alert"></div>
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js